<template>
    <sc-modal @close="$emit('close')">
        <h2>Location: {{ storeName }}</h2>

        <section class="inputs">
            <div class="wrapper">
                <h3>Override occupancy default</h3>

                <div style="display: flex;">
                    <input v-model="occupancyDefault" type="number">
                    <button class="button" @click="setOccupancyDefault" :disabled="saving">Save default</button>
                </div>

                <div class="description">
                    The occupancy default will be set to the selected value, and applied during resets.
                </div>
            </div>
            <div class="spacer"></div>

            <div class="wrapper" v-if="counters.length > 0">
                <h3>Status</h3>
                <div style="display:flex;justify-content: space-between; font-weight: 600;" class="description">
                    <div>Counter</div>
                    <div>Last interaction</div>
                </div>
                <div style="display:flex;justify-content: space-between;" v-for="c in counters" class="description" :key="c.entrance">
                    <div>
                    {{c.entrance}}
                    </div><div>{{humanized(c.last_interaction)}}</div>
                </div>
            </div>
        </section>
        <section class="inputs">

            <div class="wrapper">
                <h3>Override current occupancy</h3>

                <div style="display: flex;">
                    <input v-model="occupancy" type="number">
                    <button class="button" @click="setOccupancy" :disabled="saving">Save occupancy</button>
                </div>

                <div class="description">
                    The current occupancy will be set to the selected value when you click save.
                </div>
            </div>
            <div class="spacer"></div>

            <div class="wrapper">
                <h3>Override current limit</h3>
                <div style="display: flex;">
                    <input v-model="limit" type="number">
                    <button class="button" @click="setLimit" :disabled="saving">Save limit</button>
                </div>
                <div class="description">
                    The current limit will be set to the selected value when you click save.
                </div>
            </div>
        </section>


        <button class="button" @click="$emit('close')" :disabled="saving">Close</button>
    </sc-modal>
</template>

<script>
import ScModal from '../sc-modal';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'store-reset',
  components: {ScModal},
  props: ['storeName', 'storeId'],
  data() {
    return {
      occupancyDefault: undefined,
      occupancy: undefined,
      limit: undefined,
      store: undefined,
      saving: false,
      counters: []
    };

  },
  mounted() {
    this.fetch();
  },
  methods: {
    humanized(date) {
      return moment.duration(date).humanize(true);
    },

    fetch() {
      axios.get(`${process.env.VUE_APP_API_BASE}${process.env.VUE_APP_ENDPOINT_STORE_LIMIT}?api_key=${this.$store.getters.key}&format=json&site_id=${this.storeId}`)
        .then((res) => {
          let latest = res.data.results.find(r => r.end_time === null);
          if (latest) {
            this.limit = latest.limit;
          }
        });

      axios.get(`${process.env.VUE_APP_API_BASE}/a/occupancy/override/default/${this.storeId}?api_key=${this.$store.getters.key}`)
        .then((res) => {
          if (res.data) {
            this.occupancyDefault = res.data[res.data.length - 1].count;
          }
        });

      axios.get(process.env.VUE_APP_API_BASE + `/a/occupancy/status/${this.storeId}/?api_key=${this.$store.getters.key}`)
        .then((res) => {
          if (res.data) {
            this.counters = res.data.people_counters;
          }
        });
    },

    setOccupancyDefault() {
      this.saving = true;
      axios.post(`${process.env.VUE_APP_API_BASE}/a/occupancy/override/default?api_key=${this.$store.getters.key}`, {
        'site_id': this.storeId,
        'count': this.occupancyDefault
      })
        .then(() => {
          this.saving = false;
        });
    },

    setOccupancy() {
      this.saving = true;
      axios.post(`${process.env.VUE_APP_API_BASE}/a/occupancy/override?api_key=${this.$store.getters.key}`, {
        'timestamp': null,
        'site_id': this.storeId,
        'count': this.occupancy
      })
        .then(() => {
          this.$notify.success('Occupancy updated');
          this.saving = false;
        })
        .catch(() => {
          this.$notify.error('Could not update occupancy');
          this.saving = false;
        });
    },

    setLimit() {
      this.saving = true;
      axios.post(`${process.env.VUE_APP_API_BASE}/occupancy-limits?site_id=${this.storeId}&api_key=${this.$store.getters.key}`, {
        limit: parseInt(this.limit),
      })
        .then((res) => {
          this.limit = res.data.limit;
          this.$notify.success('Limit updated');
          this.saving = false;
        })
        .catch(() => {
          this.$notify.error('Could not update limit');
          this.saving = false;
        });
    }
  }

};
</script>

<style scoped lang="scss">

.inputs {
    display: flex;
    margin-bottom: 2em;

    .spacer {
        width: 1em;
    }

    .wrapper {
        flex: 1;
        box-sizing: border-box;

        input {
            font-size: 2em;
            widtH: 200px;
            margin: .5rem;
            text-align: center;
        }
    }

    .description {
        margin-top: .5em;
        max-width: 400px;
        font-size: .75em;
    }
}

.button {
    padding: .75rem 1.25rem;
    margin: .5rem;
    border: 4px solid $brand-primary;
    background-color: $brand-primary;
    color: #FFF;
    font-weight: bold;
    cursor: pointer;
    border-radius: 0;

    &:disabled {
        opacity: .5;
    }
}

@media only screen and (max-width: 1024px) {
    .inputs {
        max-width: initial;
        flex-flow: column;

        .spacer {
            height: 1em;
        }
    }
}

</style>